export default {
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$Modal.confirm({
        title: "退出登录提示",
        content: "<p>您正在执行退出登录操作，确定?</p>",
        onOk: () => {
          this.$api.auth.Logout().then(res => {
            // this.$util.cookie.delCookie("dqtoken", this.domain);
            // localStorage.removeItem("refresh_token");
            // localStorage.removeItem("refresh_client");
            localStorage.removeItem("USER");
            // this.$store.commit("SET_LOGOUT");
            this.$router.push("/account");
            // this.$router.go(0);
          });
        }
      });
    }
  }
};
